import { InfoBar } from '@2n/design-system';
import * as React from 'react';

export interface ISuccessBarData {
  title?: string;
  children: React.ReactNode;
}

export function FilledSuccessBar(data: ISuccessBarData) {
  return (
    <InfoBar
      variant="standard"
      type="success"
      title={data.title || undefined}
      sx={{
        backgroundColor: 'success.light',
        color: 'success.text',
      }}
    >
      {data.children}
    </InfoBar>
  );
}
